import React, { useState } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import { observer } from 'mobx-react-lite'
import { useStore } from 'store/useStore'
import { HashRouter as Router } from 'react-router-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import { makeStyles } from '@material-ui/core/styles'
import styles from './Init.styles'
import MainWindow from '../../mainWindow/MainWindow'
import DocumentationButton from '../documentationButton/DocumentationButton'
import ConfiguratorButton from '../configuratorButton/ConfiguratorButton'
import Message from '@voicekey/components-base/message/Message'
import WindowTitle from '../windowTitle/WindowTitle'
import Button from '@material-ui/core/Button'
import { SEVERITIES } from 'store/messagesStore'
import dynamicMessages from 'locales/dynamicMessages'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const useStyles = makeStyles(styles, { name: 'Init' })

function Init () {
  const classes = useStyles()

  const {
    sessionStore,
    domainStore,
    messagesStore,
    configuratorStoreSettings
  } = useStore()

  const [isFirstLoadingInProcess, setIsFirstLoadingInProcess] = useState(true)

  React.useEffect(() => {
    const getDataFromBrowserStorage = item => sessionStorage.getItem(item)
    const storedSessionId = getDataFromBrowserStorage('sessionId')
    const token = getDataFromBrowserStorage('token')
    const userConf = getDataFromBrowserStorage('userConf')
    const loadSession = async () => {
      try {
        if (storedSessionId) {
          const isSessionActive = await sessionStore.checkSessionId(storedSessionId)
          if (isSessionActive) {
            sessionStore.sessionId = storedSessionId
            domainStore.domainId = getDataFromBrowserStorage('domainId')
            sessionStore.username = getDataFromBrowserStorage('username')
          }
        } else {
          sessionStore.resetSession()
        }
        if (token && userConf) {
          const isUserActive = await configuratorStoreSettings.checkAuth(token, userConf)
          if (isUserActive) {
            configuratorStoreSettings.token = token
            configuratorStoreSettings.userConf = userConf
          }
        }
      } finally {
        setIsFirstLoadingInProcess(false)
      }
    }
    loadSession()
  }, [])

  const resetMessage = () => {
    messagesStore.setMessage()
  }

  const handleCopyBuildVersion = (text, copied) => {
    if (copied) {
      messagesStore.setMessage(dynamicMessages.build_version_copied, SEVERITIES.SUCCESS)
    } else {
      messagesStore.setMessage(dynamicMessages.unable_to_copy_build_version)
    }
  }

  return (
    <div className={classes.main}>
      <CssBaseline />
      {isFirstLoadingInProcess
        ? (
          <CircularProgress
            data-test-id='init_progress'
            color='secondary'
            size={40}
            classes={{ root: classes.MuiCircularProgress }}
          />
        )
        : (
          <Router>
            {messagesStore.message && (
              <Message onClose={resetMessage} message={messagesStore.message} />
            )}
            <WindowTitle />
            <MainWindow />
            <div className={classes.footer}>
              <div>
                <DocumentationButton />
                <ConfiguratorButton />
              </div>
              <CopyToClipboard onCopy={handleCopyBuildVersion} text={process.env.PLATFORM_VERSION}>
                <Button
                  className={classes.buildVersion}
                  variant='text'
                  disableRipple
                >
                  {process.env.PLATFORM_VERSION}
                </Button>
              </CopyToClipboard>
            </div>
          </Router>
        )}
    </div>
  )
}

export default observer(Init)
